import {confirmAlert,} from "react-confirm-alert";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import React, {useState} from "react";
import {deleteShippingCost} from "../../../../api/shippingCost";
import Button from "../../../../components/UI/Button";

const ShippingCostListTableAction = ({row, editRecord}) =>{

  const [toastId, setToastId] = useState(null);

  const queryClient = useQueryClient()

  const {mutate, isPending} = useMutation({
    mutationFn:(data)=> deleteShippingCost(data),
    onMutate: () => {
      setToastId(toast.loading("Please wait..."))
    },
    onSuccess: (response, payload) => {
      toast.update(toastId, { render: "Shipping Cost Deleted!", type: "success", isLoading: false, autoClose: true  });
      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === 'shipping_costs',
      });
    },
    onError: () => {
      toast.update(toastId, { render: "Something happened!", type: "error", isLoading: false, autoClose: true });
    }
  })

  const editHandler = ()=>{
    editRecord(row)
  }

  const deleteHandler = () => {
    confirmAlert({
      title: 'Delete',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Yes',
          className: 'btn',
          onClick: () => {
            mutate({id: row.id})
          },
        },
        {
          label: 'No',
          onClick: () => {
            return;
          },
        }
      ]
    });
  }
  return (
    <>
      <Button
          text="Edit"
          classes={"mr_5"}
          variant={"btn_transparent has_border_radius"}
          size={'btn_sm'}
          onClickHandler={editHandler}
      />
      <Button
          text="Delete"
          variant={"btn_danger has_border_radius"}
          isPending={isPending}
          size={'btn_sm'}
          onClickHandler={deleteHandler}
      />
    </>
  );
}

export default ShippingCostListTableAction;